export default __webpack_public_path__ + "static/media/ic-bussiness.37e57e39.svg";